import * as React from 'react';

// Source: https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/ideal.svg
// Transformed into <svg> tag with @svgr/cli
export const Ideal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    x={0}
    y={0}
    viewBox="0 0 40 26"
    aria-hidden
    data-testid="ideal-logo"
  >
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.979 23h-10.32C9.743 23 9 22.262 9 21.353V4.647C9 3.737 9.743 3 10.66 3h10.319c9.792 0 11.253 6.255 11.253 9.979C32.232 19.439 28.23 23 20.98 23zM10.659 3.55c-.613 0-1.106.488-1.106 1.097v16.706c0 .609.493 1.098 1.106 1.098h10.32c6.897 0 10.7-3.364 10.7-9.473 0-8.202-6.707-9.429-10.7-9.429h-10.32zm1.781 10.81a1.61 1.61 0 001.616-1.604 1.61 1.61 0 00-1.616-1.605 1.61 1.61 0 00-1.616 1.604 1.61 1.61 0 001.616 1.605zm-1.227 4.041a2.435 2.435 0 002.446 2.428h.008v-4.324c0-.678-.553-1.218-1.227-1.218-.683 0-1.227.549-1.227 1.218v1.896z"
      fill="#000"
    />
    <path
      d="M15.327 6.26v14.57h6.387c5.8 0 8.314-3.252 8.314-7.851 0-4.402-2.515-7.817-8.314-7.817h-5.281c-.614 0-1.106.498-1.106 1.098z"
      fill="#C06"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.205 11.117a1.906 1.906 0 00-.631-.103v-.009h-1.495v3.484h1.512c.268 0 .501-.052.7-.138.199-.094.363-.214.493-.369a1.64 1.64 0 00.294-.557c.06-.215.095-.447.095-.704a2.2 2.2 0 00-.121-.755 1.756 1.756 0 00-.337-.532 1.42 1.42 0 00-.51-.317zm-.355 2.685a1.094 1.094 0 01-.328.052v.008h-.683v-2.196h.553c.19 0 .346.025.476.077a.78.78 0 01.31.232.935.935 0 01.174.36c.034.137.052.3.052.472 0 .197-.026.352-.078.489a.999.999 0 01-.199.326.645.645 0 01-.277.18zm4.443-2.145v-.652h-2.619v3.484h2.662v-.644h-1.893v-.85h1.703v-.591h-1.703v-.747h1.85zm2.645-.643l1.314 3.483h-.804l-.268-.772h-1.314l-.276.772h-.778l1.322-3.483h.804zm.043 2.136l-.44-1.278h-.01l-.457 1.278h.907zm2.523.704v-2.84h-.769v3.483h2.48v-.643h-1.71z"
      fill="#fff"
    />
  </svg>
);
